import apiService from '../../../services/api'

class EventApi {
  // Страница эвента «Проклятие Skinoz» (авторизованный или гость;
  // вне эвента штатно приходит { enabled: false })
  async getHalloweenEvent(signal) {
    return apiService.makeRequest('/api/event/halloween/', {
      method: 'GET',
      signal
    })
  }

  // Банда в эвенте: прогресс, лестница и игроки, принёсшие тыквы (по любой банде)
  async getHalloweenTeam(slug, signal) {
    return apiService.makeRequest(`/api/event/halloween/team/${encodeURIComponent(slug)}/`, {
      method: 'GET',
      signal
    })
  }
}

const eventApi = new EventApi()

export default eventApi
